// Configuracao de acesso do sidebar por usuario/email.
// Evita hardcoded em AppSidebar.jsx. Atualizar aqui quando mudar quem pode ver o que.

export const SALES_RESTRICTED_ROLES = [
  'sales_consultant',
  'sales_manager',
  'sales_dev',
  'sales_director',
] as const;

export const USER_EMAILS = {
  ALAN_VITAL: 'avital@divuslegalgroup.com',
  MARIANE: 'mcarvalho@divuslegalgroup.com',
  JOSIE: 'jfagundes@divuslegalgroup.com',
  CARINE: 'cfogaca@divuslegalgroup.com',
} as const;

export const ALAN_VITAL_APP_USER_ID = '77765163-fd06-4a41-acf9-7151a3328d1f';

export const SALES_REPORT_ONLY_EMAILS = [
  'jfagundes@divuslegalgroup.com',
  'cfogaca@divuslegalgroup.com',
  'gsenna@divuslegalgroup.com',
  'rsantana@divuslegalgroup.com',
  'mcarvalho@divuslegalgroup.com',
  'avital@divuslegalgroup.com',
  'wgoes@divuslegalgroup.com',
] as const;

// Usuarios sem acesso ao modulo de Atendimento (tela, menu e canal de resposta).
export const CUSTOMER_SERVICE_BLOCKED_EMAILS = [
  'wgoes@divuslegalgroup.com',
] as const;

export const FINANCE_ADMIN_ALLOWED_EMAILS = [
  'lcosta@divuslegalgroup.com',
  'lucascosta.us@gmail.com',
  'gbumussi@divuslegalgroup.com',
  'njunior@divuslegalgroup.com',
  'atavares@divuslegalgroup.com',
] as const;
